import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-billing-errors",
  templateUrl: "./billing-errors.component.html",
})
export class BillingErrorsComponent implements OnInit {
  constructor(private appservice: AppService, private datePipe: DatePipe) {}

  pageNumber = 1;
  pageRecord = 10;
  search = "";
  searchText = "";
  billinglog = [];
  billinglogs = [];
  count = 0;
  ngOnInit() {
    const data = {
      pageNumber: this.pageNumber,
      pageRecord: this.pageRecord,
      type: "InComplete",
      search: this.search,
      countryid: "",
      stateid: "",
    };
    this.getBillingLog(data);
  }

  convertutctolocal(value, type, offset) {
    let flag;
    if (value) {
      let zoneDate = new Date(value);
      if (type === "invoice") {
        zoneDate.setDate(zoneDate.getDate() - 1);
        flag = this.datePipe.transform(
          zoneDate.setMinutes(zoneDate.getMinutes() + +offset),
          "MMM dd, yyyy"
        );
      } else {
        flag = this.datePipe.transform(
          zoneDate.setMinutes(zoneDate.getMinutes() + +offset),
          "MMM dd, yyyy"
        );
      }
    }
    return flag;
  }

  pageChanged(event) {
    const data = {
      pageNumber: event.page,
      pageRecord: this.pageRecord,
      type: "InComplete",
      search: this.search,
      countryid: "",
      stateid: "",
    };
    this.getBillingLog(data);
  }

  searchbilling(value) {
    this.search = value;
    const data = {
      pageNumber: 1,
      pageRecord: this.pageRecord,
      type: "InComplete",
      search: this.search,
      countryid: "",
      stateid: "",
    };
    this.getBillingLog(data);
  }

  getBillingLog(data) {
    this.appservice.getBillingApprovedReport(data).subscribe((res) => {
      if (res && res["entity"]) {
        this.billinglog = [];
        this.billinglogs = [];
        this.count = res["count"];
        for (let index = 0; index < res["entity"].length; index++) {
          const groupBy = this.convertutctolocal(
            res["entity"][index].createdOn,
            "",
            res["entity"][index].offSet
          );
          res["entity"][index].formatedCreatedOn = groupBy;
          this.billinglogs[index] = res["entity"][index];
          this.billinglogs[index].groupBy = groupBy.toString().substring(0, 10);
        }
        this.billinglog = this.groupBy(this.billinglogs, "groupBy");

        for (let index = 0; index < this.billinglog.length; index++) {
          let totalAmount = 0;

          for (let j = 0; j < this.billinglog[index].value.length; j++) {
            totalAmount += this.getRound(
              +this.billinglog[index].value[j].paidAmount
            );

            if (this.billinglog[index].value.length === j + 1) {
              this.billinglog[index].value[j].totalAmount = +totalAmount;
            }
          }
        }
      }
    });
  }
  getRound(value): number {
    if (value) {
      return Math.round(value * 100) / 100;
    }
    return 0;
  }
  groupBy(collection: any, property: string): any {
    if (!collection) {
      return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
      if (!previous[current[property]]) {
        previous[current[property]] = [current];
      } else {
        previous[current[property]].push(current);
      }
      return previous;
    }, {});
    return Object.keys(groupedCollection).map((key) => ({
      key,
      value: groupedCollection[key],
    }));
  }
  refreshPatient() {
    this.searchText = "";
    const data = {
      pageNumber: 1,
      pageRecord: this.pageRecord,
      type: "InComplete",
      search: "",
      countryid: "",
      stateid: "",
    };
    this.getBillingLog(data);
  }
}
